import React from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import MaterialsToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import "./toggleButtonGroup.scss";
import Notification from "../notification/notification";
import TooltipInfo from "../tooltipInfo/tooltipInfo";
import { FormControl, FormHelperText } from "@material-ui/core";

interface ToggleButtonGroupProps {
  options: OptionModel[];
  question: string | null;
  value?: string | null;
  errorMessage?: string | null | undefined;
  infoMessage?: string | null | undefined;
  contextHelp?: string;
  onChange: (newValue: string) => void;
  disabled?: boolean;
  className?: string;
}

interface OptionModel {
  value: string;
  label: string;
}

export default function ToggleButtonGroupCustom(props: ToggleButtonGroupProps) {
  const onChangeValue = (event: React.MouseEvent<HTMLElement>, newValue: string) => {
    if (newValue) {
      props.onChange(newValue);
    }
  };

  return (
    <div className={`toggle-button-group ${props.className ? props.className : ""}`}>
      <div className="question-answer-container">
        <div className="question">{props.question}
          {props.contextHelp && (
            <div className="tooltip">
              <TooltipInfo infoMessage={props.contextHelp} />
            </div>
          )}
        </div>

        <FormControl className={"form-control"}>
          <MaterialsToggleButtonGroup

            value={props.value}
            exclusive
            onChange={onChangeValue}
          >
            {props.options.map((option: OptionModel) => (
              <ToggleButton
                disabled={props.disabled}
                key={"option_" + option.value}
                value={option.value}
                className={(props.errorMessage) ? "error-button option-button" : "option-button"}
              >
                {option.label}
              </ToggleButton>
            ))}
          </MaterialsToggleButtonGroup>
          {props.errorMessage && (
            <FormHelperText>
              <Notification type="error" message={props.errorMessage} />
            </FormHelperText>
          )}
        </FormControl>
      </div>
      {props.infoMessage && (
        <Notification type="info" message={props.infoMessage} />
      )}
    </div>
  );
}
